import { useState, useEffect, useCallback } from 'react';
import { createClient } from '../supabase/client';

let globalBenchmarkEmojiMap: Record<string, string> | null = null;
let loadPromise: Promise<Record<string, string>> | null = null;

async function fetchBenchmarkEmojis(): Promise<Record<string, string>> {
  if (globalBenchmarkEmojiMap) return globalBenchmarkEmojiMap;
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    const supabase = createClient();
    const { data } = await supabase
      .from('benchmark_emojis')
      .select('full_ticker, emoji');

    const map: Record<string, string> = {};
    (data || []).forEach((r: any) => {
      map[r.full_ticker] = r.emoji;
    });
    globalBenchmarkEmojiMap = map;
    return map;
  })();

  return loadPromise;
}

export function useBenchmarkEmojis() {
  const [emojiMap, setEmojiMap] = useState<Record<string, string>>(globalBenchmarkEmojiMap || {});

  useEffect(() => {
    fetchBenchmarkEmojis().then(setEmojiMap);
  }, []);

  const getBenchmarkEmoji = useCallback(
    (fullTicker: string): string | null => {
      if (!fullTicker || !fullTicker.endsWith('.B')) return null;
      return emojiMap[fullTicker] || null;
    },
    [emojiMap]
  );

  return getBenchmarkEmoji;
}
